import { useTranslation } from 'react-i18next';

import { Heading, Paragraph } from '@app/shared/ui/atoms/Common';
import { LanguageSelect } from '@app/shared/ui/molecules/Profile';

interface HeaderProps {
  onLanguageChange: (value: string) => Promise<void>;
}

export function Header({ onLanguageChange }: HeaderProps) {
  const { i18n, t } = useTranslation();

  return (
    <header className="flex flex-col items-center gap-[10px]">
      <div className="flex items-center gap-1 rounded-[6px] bg-secondary-foreground/20 p-[4px_8px]">
        <LanguageSelect value={i18n.language} onValueChange={onLanguageChange} hasText />
      </div>

      <Heading className="text-center">{t('loader.remember')}</Heading>
      <Paragraph variant="secondary" className="text-center">
        {t('auth.enter_data')}
      </Paragraph>
    </header>
  );
}
